import styled from "styled-components"
import {Col} from "react-bootstrap"

import {ReactTable} from "../../../Table"

export const StyledCol = styled(Col)`
  padding-left: 0px;
  padding-right: 0px;
  margin-bottom: ${({theme}) => theme.spacing.two};
`

export const Table = styled(ReactTable)`
  margin-bottom: ${({theme}) => theme.spacing.one};
  .rt-th.-sort-asc,
  .rt-th.-sort-desc {
    box-shadow: none !important;
  }
  .rt-tbody {
    border-top: 2px solid ${({theme}) => theme.colors.greys.darkGrey};
    border-bottom: 2px solid ${({theme}) => theme.colors.greys.darkGrey};
  }
`
